<template>
    <div>
            <p class="px-0 my-2 pb-4"><span class="text-danger font-weight-bold">توجه :</span> در صورت تغییر ندادن رنگ های زیر، سیستم به
                صورت پیشفرض رنگ های انتخاب شده زیر را در سفارش شما لحاظ می کند.</p>
            <div class="row">
                <div class="col-md-4 boxStyle p-2 my-2" v-for="(item,index) in selectedImage" :key="item">
                    <div class="row m-2">
                        <v-btn
                                color="success"
                                elevation="2"
                                fab
                                @click="addColor"
                                outlined
                                x-small
                                class="mx-2"
                        ><i class="fa fa-plus"></i></v-btn>
                        <v-btn
                                color="error"
                                v-if="selectedImage.length > 1"
                                elevation="2"
                                fab
                                @click="removeColor(index)"
                                outlined
                                x-small
                        ><i class="fa fa-minus"></i></v-btn>

                    </div>
                    <p class="text-center"> رنگ {{ index + 1 }}</p>
                    <p class="text-center"> {{ item }}</p>

                    <v-color-picker
                            v-model="selectedImage[index]"
                            label="رنگ"
                            outlined
                            required
                            dense
                            :draggable="true"
                            class="mt-1"
                            mode="hexa"
                            dot-size="18"
                            show-swatches
                            swatches-max-height="135"
                    ></v-color-picker>

                </div>
            </div>
    </div>
</template>

<script>

export default {
    name: "colorPickers",
    props: {
        count: {
            default: 2
        }
    },
    data() {
        return {
            selectedImage: [
                "#B71C1C"
            ],
        }
    },
    methods: {
        addColor() {
            if (this.selectedImage.length <= this.count)
                this.selectedImage.push("#B71C1C")
            else
                return false;
        },
        removeColor(index) {
            this.selectedImage.splice(this.selectedImage.indexOf(index), 1);
        },
    },
    watch: {
        selectedImage() {
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>